import { render, staticRenderFns } from "./Term-Selector.vue?vue&type=template&id=a56d08be&lang=pug"
import script from "./Term-Selector.vue?vue&type=script&setup=true&lang=ts"
export * from "./Term-Selector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Term-Selector.vue?vue&type=style&index=0&id=a56d08be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports